import React from "react";
import ReactDOM from "react-dom";
import "./Assets/Css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));